import React, { useEffect } from "react";

import "./index.css";

export default function Hex(props) {
  useEffect(() => {
    if (props.type === "start") {
      props.logStart();
    }
  }, []);

  useEffect(() => {
    if (props.type === "start" && props.currentActive === 0) {
      props.logLatestSection(props.type);
    } else if (props.type === "end" && props.percent === 100) {
      props.logLatestSection(props.type);
    } else if (props.currentActive === props.index + 1) {
      props.logLatestSection(props.type);
    }
  }, [props.currentActive]);

  return (
    <div aria-hidden="true">
      <svg
        aria-hidden="true"
        className="splash-label-hex"
        style={{ transform: props.type !== "custom" ? "scale(0.7)" : null }}
        fill={
          props.type === "start"
            ? "rgb(250,172,72)"
            : props.type === "end" && props.percent === 100
              ? "rgb(250,172,72)"
              : props.currentActive >= props.index + 1
                ? "rgb(250,172,72)"
                : "white"
        }
        width="36"
        height="42"
        viewBox="0 0 36 42"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.5 10.681L18 0.57735L35.5 10.681V30.8882L18 40.9919L0.5 30.8882V10.681Z"
          stroke="transparent"
        />
      </svg>
    </div>
  );
}
